
































import Vue from 'vue';
import { IFooterBaseComponent } from '@/common/interfaces/footer.interface';
import AboutUs from './AboutUs.vue';
import DesktopLogos from './DesktopLogos.vue';
import FooterHeadline from './FooterHeadline.vue';
import HelpAndContact from './HelpAndContact.vue';
import OpeningHours from './OpeningHours.vue';
import PaymentTypes from './PaymentTypes.vue';

export default Vue.extend({
  name: `FooterDesktop`,
  components: {
    AboutUs,
    DesktopLogos,
    FooterHeadline,
    HelpAndContact,
    OpeningHours,
    PaymentTypes,
  },
  data(): IFooterBaseComponent {
    return {
      aboutUs: window.vueFooter.aboutUs,
      helpAndContact: window.vueFooter.helpAndContact,
      openingHours: window.vueFooter.openingHours,
      paymentTypes: window.vueFooter.paymentTypes,
    };
  },
});
